import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { getMe } from "../crud/auth.crud";
import { actions } from "../store/ducks/auth.duck";

export default function AtualizarSessao() {
	const dispatch = useDispatch();
	const store = useStore();
	const persona = useSelector(({ auth: { user } }) => user?.token_type);
	const autenticado = useSelector(({ auth: { authToken } }) => !!authToken);

	useEffect(() => {
		if (!autenticado || !persona) return;

		getMe(persona)
			.then(({ data }) => {
				const { user, permissions, empresas_acessiveis: empresasAcessiveis } = data?.data || {};
				if (!user) return;

				dispatch(actions.fulfillUser({ ...store.getState().auth.user, ...user, empresas_acessiveis: empresasAcessiveis }));
				dispatch(actions.atualizarPermissoes(permissions));
			})
			.catch(() => {});
	}, [autenticado, persona, dispatch]);

	return null;
}
